import { render } from "./corporates.vue?vue&type=template&id=ef6d176c&scoped=true"
import script from "./corporates.vue?vue&type=script&lang=js"
export * from "./corporates.vue?vue&type=script&lang=js"

import "./corporates.vue?vue&type=style&index=0&id=ef6d176c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6d176c"]])

export default __exports__